import createIcon from '../../createIcon';

/**
 * @component @name Park
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOTQ5OCAxMkgxOC45NDk4TDExLjk0OTggMkw0Ljk5OTggMTJINi45NDk4TDMuMDQ5OCAxOEg5Ljk2OTgxVjIySDEzLjkyOThWMThIMjAuOTQ5OEwxNi45NDk4IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Park = createIcon('Park', [
  [
    'path',
    {
      d: 'M16.9498 12H18.9498L11.9498 2L4.9998 12H6.9498L3.0498 18H9.96981V22H13.9298V18H20.9498L16.9498 12Z',
      key: '5lilui',
    },
  ],
]);

export default Park;
